import { setReferrerType } from './action-types';

export function setReferrer(windowReferrer) {
	return {
		type: setReferrerType,
		referrer: windowReferrer || '',
	};
}
